import React from 'react';
import { Routes, Route } from '@leagueplatform/routing';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { MasonryGetCareLandingPage } from './pages/masonry-get-care-landing/masonry-get-care-landing.page';
import { GetCareLandingPage } from './pages/get-care-landing/get-care-landing.page';
import { useCareDiscoveryConfig } from './care-discovery.config';
import { QuickActionPage } from './pages/quick-action/quick-action.page';

const LandingPage = (): React.JSX.Element => {
  const { data: isMasonryDisabled, isLoading } = useFeatureFlagQuery(
    'disable_care_masonry_page',
  );

  const hasMasonryId = !!useCareDiscoveryConfig().masonryAppId?.left;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return hasMasonryId && !isMasonryDisabled ? (
    <MasonryGetCareLandingPage />
  ) : (
    <GetCareLandingPage />
  );
};

export const CareDiscoveryRoutes = (): JSX.Element => (
  <Routes>
    <Route index element={<LandingPage />} />
    <Route
      path="submenu/benefits-and-coverage/:quickActionId/*"
      element={<QuickActionPage />}
    />
  </Routes>
);

export const CareDiscoveryRoutesBrowserRouter = [
  {
    path: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
    element: <LandingPage />,
  },
  {
    path: `${getModulePath(
      LEAGUE_MODULE_NAMES.careDiscovery,
    )}/submenu/benefits-and-coverage/:quickActionId`,
    element: <QuickActionPage />,
  },
];
